import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const PinZipIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M12 2C8.134 2 5 5.134 5 9C5 13.192 9.922 19.84 11.511 21.767C11.766 22.076 12.234 22.076 12.489 21.767C14.078 19.84 19 13.192 19 9C19 5.134 15.866 2 12 2ZM15 12H9C8.448 12 8 11.552 8 11V7C8 6.448 8.448 6 9 6H11V7C11 7.552 11.448 8 12 8C12.552 8 13 7.552 13 7V6H15C15.552 6 16 6.448 16 7V11C16 11.552 15.552 12 15 12Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

PinZipIcon.propTypes = {
  sx: PropTypes.object,
};

export default PinZipIcon;
